import * as React from 'react';

import {ErrorMessage} from '../form/error-message';

import styles from './error-list.module.css';

type Props = {
    errors: string[];
};

export class ErrorList extends React.PureComponent<Props> {
    render() {
        return (
            <ul className={styles['error-list']}>
                {this.props.errors.map((error, index) => {
                    return (
                        <ErrorMessage key={index} as='li'>
                            {error}
                        </ErrorMessage>
                    );
                })}
            </ul>
        );
    }
}
